import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            passwordComplexityErrorMessage: String,
            passwordsDoNotMatchErrorMessage: String
        };
    }

    static get targets() {
        return [
            "passwordInput",
            "passwordConfirmationInput",
            "passwordComplexityErrorMessage",
            "passwordsDoNotMatchErrorMessage",
            "hasLowerAndUpperCaseCharactersIcon",
            "hasNumericCharactersIcon",
            "hasSpecialCharactersIcon",
            "hasSufficientCharactersIcon"
        ];
    }

    checkPasswordStrength() {
        [
            [this.hasLowerAndUpperCaseCharactersIconTarget, /[A-Z]/.test(this.passwordInputTarget.value) && /[a-z]/.test(this.passwordInputTarget.value)],
            [this.hasNumericCharactersIconTarget, /[0-9]/.test(this.passwordInputTarget.value)],
            [this.hasSpecialCharactersIconTarget, /[!,%,&,@,#,$,^,*,?,_,~]/.test(this.passwordInputTarget.value)],
            [this.hasSufficientCharactersIconTarget, this.passwordInputTarget.value.length >= 8]
        ].forEach(([iconTarget, isValid]) => {
            iconTarget.textContent = isValid ? "check_circle" : "cancel";
            iconTarget.classList.toggle("text-success", isValid);
        });
        const isPasswordStrongEnough =
            this.passwordInputTarget.value.length === 0 ||
            [
                this.hasLowerAndUpperCaseCharactersIconTarget,
                this.hasNumericCharactersIconTarget,
                this.hasSpecialCharactersIconTarget,
                this.hasSufficientCharactersIconTarget
            ].every(it => it.classList.contains("text-success"));
        this.passwordComplexityErrorMessageTarget.textContent = !isPasswordStrongEnough ? this.passwordComplexityErrorMessageValue : "";
        this.passwordComplexityErrorMessageTarget.classList.toggle("field-validation-error", !isPasswordStrongEnough);
    }

    checkPasswordsMatch() {
        const hasMatchingPasswords = this.passwordInputTarget.value.length === 0 || this.passwordInputTarget.value === this.passwordConfirmationInputTarget.value;
        this.passwordsDoNotMatchErrorMessageTarget.textContent = !hasMatchingPasswords ? this.passwordsDoNotMatchErrorMessageValue : "";
        this.passwordsDoNotMatchErrorMessageTarget.classList.toggle("field-validation-error", !hasMatchingPasswords);
    }
}